import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { GetTempInoperative, MakeTempInoperative } from '../../../actions/shops'
import { renderFullDate } from '../../../utils/time'

// Components
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

// Elements
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Text from '../../../shared/elements/text'
import Button from '../../../shared/elements/button'
import Inline from '../../../shared/elements/inline'
import Label from '../../../shared/elements/label'
import DateTime from '../../../shared/elements/datetime'
import RemoveButton from '../../../shared/elements/removeButton'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Styles
import './tempInoperative.scss'

// Is a flaggable enum
const CarRentalServicePeriodTypes = {
  TempUnavailable: 1
}

class TempInoperative extends Component {
  constructor (props) {
    super(props)

    this.state = {
      carId: 0,
      logs: [],
      dateStart: moment(),
      dateEnd: moment().add(1, 'd'),
      comment: '',
      confirm: {
        open: false
      }
    }

    this.onDateStartChange = this.onDateStartChange.bind(this)
    this.onDateEndChange = this.onDateEndChange.bind(this)
    this.onCommentChange = this.onCommentChange.bind(this)
    this.renderLog = this.renderLog.bind(this)
    this.makeTempInoperative = this.makeTempInoperative.bind(this)
    this.getTempInoperative = this.getTempInoperative.bind(this)
    this.deleteService = this.deleteService.bind(this)
    this.closePopup = this.closePopup.bind(this)
  }

  componentDidMount () {
    this.getTempInoperative(this.props.rentalCarId)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.rentalCarId !== this.state.carId) {
      this.getTempInoperative(nextProps.rentalCarId)
    }
  }

  getTempInoperative (rentalCarId) {
    this.props.GetTempInoperative(rentalCarId).then(res => {
      this.setState({
        logs: res.data,
        carId: rentalCarId,
        comment: ''
      })
    })
  }

  onDateStartChange (date) {
    this.setState({
      dateStart: date
    })
  }

  onDateEndChange (date) {
    this.setState({
      dateEnd: date
    })
  }

  onCommentChange (e) {
    const { name, value } = e.target
    this.setState({
      [name]: value
    }, () => console.log('state', this.state))
  }

  makeTempInoperative () {
    const { dateStart, dateEnd } = this.state

    if (dateStart.isAfter(dateEnd) || dateStart.isSameOrBefore(moment().add(-1, 'd')) || dateEnd.isSameOrBefore(moment().add(-1, 'd'))) {
      window.toastr.error(translation('391'), translation('216'))
      return
    }

    let inoperativeCar = {
      StartDate: this.state.dateStart,
      EndDate: this.state.dateEnd,
      Comment: this.state.comment,
      Type: CarRentalServicePeriodTypes.TempUnavailable,
      IsDeleted: false,
      CarRentalId: this.state.carId
    }
    this.props.MakeTempInoperative(inoperativeCar).then((res) => {
      this.setState({
        logs: res.data
      })
      if (typeof this.props.OnUpdateCallback === 'function') this.props.OnUpdateCallback()
    }, (err) => {
      if (err.response.data !== undefined) {
        let error = err.response.data
        // Toastr
        window.toastr.error(translation(error), translation('216'))
      }
    })
  }

  deleteService () {
    let inoperativeCar = {
      Id: this.state.deleteId,
      IsDeleted: true,
      CarRentalId: this.state.carId
    }
    this.props.MakeTempInoperative(inoperativeCar).then((res) => {
      this.setState({
        logs: res.data,
        confirm: {
          open: false
        }
      })
      if (typeof this.props.OnUpdateCallback === 'function') this.props.OnUpdateCallback()
    })
  }

  closePopup () {
    this.setState({
      confirm: {
        open: false
      }
    })
  }

  renderLog (log, key) {
    const openConfirm = (id) => {
      this.setState({
        deleteId: id,
        confirm: {
          open: true
        }
      })
    }
    return (
      <Inline fillChildNum={[0]} key={key} block spacing={2}>
        <div>
          <Inline>
            <Label>{translation('434')}:</Label>
            <Label>{renderFullDate(log.StartDate, false) + ' - ' + renderFullDate(log.EndDate, false)}</Label>
          </Inline>
          <Inline spacing={0}>
            <Label>{translation('333')}:</Label>
            <Label>{log.Comment}</Label>
          </Inline>
        </div>
        {hasSubscriptionPermission(this.props.auth, 10, 11) && (
          <RemoveButton round size='m' onClick={openConfirm.bind(this, log.Id)} disabled={!hasSubscriptionPermission(this.props.auth, 10, 11)} />
        )}
      </Inline>
    )
  }

  render () {
    const { dateStart, dateEnd, comment } = this.state
    const hasPerm = hasSubscriptionPermission(this.props.auth, 10, 11)

    return (
      <Panel title={translation('15103')}>
        {this.state.logs.map(this.renderLog)}
        <LabelWrapper labelText={translation('434')}>
          <Inline>
            <DateTime
              className='inop__date'
              inputProps={{ name: 'dateStart', className: 'inop__date-input', disabled: !hasPerm }}
              closeOnSelect
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              value={dateStart}
              onChange={this.onDateStartChange} />
            <DateTime
              className='inop__date'
              inputProps={{ name: 'dateEnd', className: 'inop__date-input', disabled: !hasPerm }}
              closeOnSelect
              dateFormat='DD-MM-YYYY'
              timeFormat={false}
              value={dateEnd}
              onChange={this.onDateEndChange} />
          </Inline>
        </LabelWrapper>
        <Text name='comment' value={comment} onChange={this.onCommentChange} disabled={!hasPerm} labelText={translation('333')} />
        <Button onClick={this.makeTempInoperative} disabled={!hasPerm} labelText={translation('27')}>
          {/* <img src='/images/icons/circle_plus22.png' /> */}
        </Button>
        {this.state.confirm.open && (
          <Portal className='deleteModal' onPortalClose={this.closePopup}>
            <Confirm confirm={this.deleteService} notConfirm={this.closePopup} renderText={() => translation('15122')} />
          </Portal>
        )}
      </Panel>
    )
  }
}

TempInoperative.defaultProps = {
  rentalCarId: undefined,
  OnUpdateCallback: () => {}
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetTempInoperative,
  MakeTempInoperative
})(TempInoperative)



// WEBPACK FOOTER //
// ./src/app/pages/CarRental/TempInoperative/index.js